import React, { useState } from 'react';
import './FAQ.css';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: 'Como funciona a integração com o GitHub?',
    answer: 'A integração é feita através do OAuth do GitHub. Você autoriza o acesso aos seus repositórios e nós coletamos as métricas de Pull Requests, Reviews e Deployments de forma segura e automatizada.'
  },
  {
    question: 'Serei cobrado por todos os desenvolvedores da minha organização?',
    answer: 'Não, você será cobrado por desenvolvedores ativos na sua organização. Se um desenvolvedor não estiver ativo, você não será cobrado por ele.'
  },
  {
    question: 'O que é considerado um desenvolvedor ativo?',
    answer: 'É considerado um desenvolvedor ativo todo usuário que abrir ou revisar um Pull Request.'
  },
  {
    question: 'Quais métricas são coletadas?',
    answer: 'Coletamos métricas como Mean Cycle Time, Mean Lead Time, Mean Review Time, Throughput, Review Coverage, PR Rate OnDay, Mean PR Size e Merge PR Rate. Todas as métricas são calculadas automaticamente a partir dos dados do GitHub.'
  },
  {
    question: 'Meus dados estão seguros?',
    answer: 'Sim! Utilizamos autenticação OAuth do GitHub e armazenamos os dados de forma segura. Você pode revogar o acesso a qualquer momento através das configurações do GitHub. Não armazenamos código fonte, apenas metadados e métricas.'
  },
  {
    question: 'Posso mudar de plano depois?',
    answer: 'Sim, você pode fazer upgrade ou downgrade do seu plano a qualquer momento. As mudanças são aplicadas imediatamente e os valores são ajustados proporcionalmente.'
  },
  {
    question: 'Quantos repositórios posso monitorar?',
    answer: 'No plano Starter você pode monitorar até 5 repositórios. No plano Pro, não há limite de repositórios. O plano Enterprise oferece configurações customizadas conforme suas necessidades.'
  },
  {
    question: 'Preciso instalar algo no meu repositório?',
    answer: 'Não é necessário instalar nada. A integração é feita apenas através da autorização OAuth. Opcionalmente, você pode configurar webhooks para atualizações em tempo real, mas isso é opcional.'
  },
  {
    question: 'Como funciona o suporte?',
    answer: 'O plano Starter inclui suporte por email. O plano Pro oferece suporte prioritário com resposta mais rápida. O plano Enterprise inclui suporte 24/7 e um gerente de conta dedicado.'
  },
  {
    question: 'Posso testar antes de contratar?',
    answer: 'Sim! Oferecemos um período de teste gratuito para você explorar todas as funcionalidades. Entre em contato conosco para mais informações sobre o período de trial.'
  }
];

export const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleQuestion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="faq-section">
      <div className="faq-container">
        <div className="faq-header">
          <h2 className="faq-title">Perguntas Frequentes</h2>
          <p className="faq-subtitle">
            Tire suas dúvidas sobre o Opsight e como podemos ajudar seu time
          </p>
        </div>
        <div className="faq-list">
          {faqData.map((item, index) => (
            <div 
              key={index} 
              className={`faq-item ${openIndex === index ? 'open' : ''}`}
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <button 
                className="faq-question"
                onClick={() => toggleQuestion(index)}
                aria-expanded={openIndex === index}
              >
                <span className="faq-question-text">{item.question}</span>
                <span className="faq-icon">
                  {openIndex === index ? '−' : '+'}
                </span>
              </button>
              <div className="faq-answer">
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};







